import Vue from 'vue';
const userHub = new Vue();

export default userHub;